import { HStack } from "native-base";

export const LegendItem = ({ children }) => (
  <HStack alignItems="center" space={{ base: 1 }}>
    {children}
  </HStack>
);
